<section class="comments-section">
  <div class="row comment" *ngFor="let review of reviews$ | async">
    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-9">
          <span class="profile-badge">
            <span>{{review.author.firstName.charAt(0) + review.author.lastName.charAt(0)}}</span>
          </span>
          <span class="name">{{review.author.firstName}} {{review.author.lastName}}</span>
          <span class="time">{{review.date | date: 'short'}}</span>
        </div>
        <div class="col-xs-3 end-xs action-buttons" *ngIf="currentUser.id === review.author.id">
          <!-- only the logged in user can edit or delete their own comments. -->
          <button mat-icon-button (click)="editReview(review.id)" [disabled]="editingReview" *ngIf="!readOnly">
            <mat-icon class="link">edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteComment(review)" [disabled]="editingReview" *ngIf="!readOnly">
            <mat-icon class="link">delete</mat-icon>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 comment-text" *ngIf="(editingReview && editingReview !== review.id) || !editingReview">
          <p>{{ review.text }}</p>
        </div>

        <div class="row comment-box" *ngIf="editingReview === review.id">
          <mat-form-field class="col-xs-12" appearance="outline">
            <mat-label [innerHTML]="'$common_comment' | translate"></mat-label>
            <textarea #textareaReview matInput rows="3" [value]="review.text"></textarea>
          </mat-form-field>
          <div class="row end-xs">
            <div class="col-xs-12">
              <button mat-button (click)="updateComment(textareaReview.value, review.id, put)" [innerHTML]="'$btn_save_comment' | translate"></button>
              <button mat-button (click)="turnEditModeOff()"  [innerHTML]="'$btn_cancel' | translate"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!readOnly">
    <div class="row comment-box">
      <mat-form-field class="col-xs-12" appearance="outline">
        <mat-label [innerHTML]="'$common_comment' | translate"></mat-label>
        <textarea #textarea matInput rows="8"></textarea>
      </mat-form-field>
    </div>
    <div class="row end-xs">
      <div class="col-xs-12">
        <button mat-button (click)="addComment(textarea.value); textarea.value=''" [innerHTML]="'$btn_post_comment' | translate"></button>
      </div>
    </div>
  </ng-container>
</section>